import { useIntl } from 'react-intl';
import { Stack, ToggleButton, ToggleButtonGroup } from '@rossum/ui/material';
import { ExtensionsView } from '../../../../../types/extensions';

type Props = {
  activeView: ExtensionsView;
  onViewChange: (view: ExtensionsView) => void;
};

export const ViewSwitcher = ({ activeView, onViewChange }: Props) => {
  const intl = useIntl();

  return (
    <Stack sx={{ pl: 3 }}>
      <ToggleButtonGroup
        value={activeView}
        exclusive
        onChange={(_, value: ExtensionsView) => {
          if (value !== null) {
            onViewChange(value);
          }
        }}
        color="primary"
        size="small"
      >
        {(['list', 'graph'] as const).map(viewType => (
          <ToggleButton
            key={viewType}
            value={viewType}
            aria-label={viewType}
            sx={{ px: 2 }}
            data-cy={`extensions-${viewType}-view`}
            color="secondary"
          >
            {intl.formatMessage({
              id: `containers.settings.extensions.view.${viewType}`,
            })}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
